// Format/parse times in the job location's timezone (e.g. Asia/Kolkata → IST).
const partsIn = (date, tz) =>
  Object.fromEntries(new Intl.DateTimeFormat("en-US", {
    timeZone: tz, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit",
  }).formatToParts(date).map((p) => [p.type, p.value]));

export const tzAbbr = (tz, date = new Date()) => {
  const p = new Intl.DateTimeFormat("en-US", { timeZone: tz, timeZoneName: "short" }).formatToParts(date).find((x) => x.type === "timeZoneName");
  const v = p?.value || tz;
  return tz === "Asia/Kolkata" && /GMT\+5:30/.test(v) ? "IST" : v;
};

export const fmtInTz = (iso, tz) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return String(iso);
  if (!tz) return d.toLocaleString();
  const s = d.toLocaleString("en-US", { timeZone: tz, weekday: "short", month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
  return `${s} ${tzAbbr(tz, d)}`;
};

// "YYYY-MM-DDTHH:MM" value for <input type=datetime-local>, as wall-clock in tz.
export const toTzInput = (date, tz) => {
  const p = partsIn(date, tz);
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
};

// Inverse of toTzInput: wall-clock in tz → UTC Date.
export const fromTzInput = (value, tz) => {
  const [d, t] = value.split("T");
  const [y, mo, da] = d.split("-").map(Number);
  const [h, mi] = t.split(":").map(Number);
  const guess = Date.UTC(y, mo - 1, da, h, mi);
  const offset = (dt) => { const p = partsIn(new Date(dt), tz); return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second) - dt; };
  let utc = guess - offset(guess);
  utc = guess - offset(utc);
  return new Date(utc);
};
